import History from "../history.js";
export default {
  methods: {
    __addHistory: function __addHistory() {
      var _this = this;

      this.__historyEntry = {
        condition: function condition() {
          return _this.hideOnRouteChange === true;
        },
        handler: this.hide
      };
      History.add(this.__historyEntry);
    },
    __removeHistory: function __removeHistory() {
      if (this.__historyEntry !== void 0) {
        History.remove(this.__historyEntry);
        this.__historyEntry = void 0;
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.showing === true && this.__removeHistory();
  }
};